import { render, staticRenderFns } from "./HomeworkStudy.vue?vue&type=template&id=2a6d26d8&scoped=true"
import script from "./HomeworkStudy.vue?vue&type=script&lang=ts"
export * from "./HomeworkStudy.vue?vue&type=script&lang=ts"
import style0 from "./HomeworkStudy.vue?vue&type=style&index=0&id=2a6d26d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d26d8",
  null
  
)

export default component.exports